export default "__VITE_ASSET__B7wlKUa8__"